<template>
  <div class="news-detail">
    <combanner></combanner>
    <div class="news-deta-upper com-padding-top-90 com-padding-bottom-90">
      <div class="com-content-1340">
        <div class="dn-upper">
          <div class="dp-ti1">{{ dataDetail.title }}</div>
          <div class="dp-intr1">
            时间：{{ dataDetail.create_time }} | 来源：{{ dataDetail.from }}
          </div>
        </div>
        <div class="dn-lower">
          <div class="com-richtext1" v-html="dataDetail.note">

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      news_id: this.$route.params.news_id,
      dataDetail: ''
    }
  },
  created() {
    this.dataRequestnews_getNewsContent()
  },

  methods: {
    // 新闻详情
    dataRequestnews_getNewsContent() {
      let params = {
        news_id: this.news_id,
      }
      this.$api.user.news_getNewsContent(params).then(res => {
        this.dataDetail = res.data.info
      })
    },
  }
}
</script>

<style scoped lang="scss">
.news-deta-upper {
  .dn-upper {
    text-align: center;

    .dp-ti1 {
      color: #2d2c2c;
      font-size: 22px;
      margin: 0 0 5px;
    }
  }

  .dn-lower {
    padding: 40px 0 0;
    margin: 30px 0 0;
    border-top: 1px solid $line1;

  }
}

@media screen and (max-width: 768px) {
  .news-deta-upper {
    .dn-upper {
      .dp-ti1 {
        font-size: 32*$mobile-conversion;
        margin: 0 0 5*$mobile-conversion;
      }
    }

    .dn-lower {
      padding: 40*$mobile-conversion 0 0;
      margin: 30*$mobile-conversion 0 0;
    }
  }
}
</style>
